import withLazy from 'hoc/withLazy';

const TournamentInfo = () =>
    import(
        /* webpackChunkName: "components-TournamentInfo" */ './TournamentInfo'
    );

export default withLazy(TournamentInfo);
